/** Constantes default de UrlContext — denylist, domínios e selectors. */

export const DEFAULT_URL_CONTEXT_DENYLIST: readonly string[] = [
  'token',
  'access_token',
  'refresh_token',
  'id_token',
  'password',
  'pass',
  'pwd',
  'email',
  'phone',
  'cpf',
  'cnpj',
  'document',
  'card',
  'cc',
  'credit_card',
  'cvv',
  'cvc',
  'auth',
  'code',
  'sessionId',
  'internalSessionId',
  'pixelSessionId',
];

export const DEFAULT_URL_CONTEXT_EXCLUDED_DOMAINS: readonly string[] = [
  'facebook.com',
  'google.com',
  'youtube.com',
  'instagram.com',
  'wa.me',
  'whatsapp.com',
  't.me',
  'telegram.me',
];

export const DEFAULT_URL_CONTEXT_EXCLUDE_SELECTORS: readonly string[] = [
  '[data-no-url-context]',
  '[download]',
];

export const SID_EXCLUDE_SELECTOR = '[data-no-sid]';

export const DEFAULT_URL_CONTEXT_SID_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 30;
